import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TextField,
  MenuItem,
} from "@mui/material";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import SimpleReactValidator from "simple-react-validator";

import { evaluateBService } from "../../../service/manage/evaluate/evaluate_b.service.js";
import { Spinner } from "react-bootstrap";
import {
  sweetErrorAlert,
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import { Stack, Chip, IconButton } from "@mui/material";
import { Cancel, AddCircleOutline } from "@material-ui/icons";
import ManageEditFormSetupModel from "./ManageEditFormSetupModel.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

class ManageFormSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading: false,
      isLoading: false,
      items: [],
      choices: [],
      title: "",
      description: "",
      currentItem: "",
      currentChoice: "",
      currentWeight: 0,
      show_user: true,
      addItemModal: false,
      editFormSetupModal: false,
      editprivilage:false,
    };
    this.createValidationsInstance();
  }

  componentDidMount() {
    const { privilege_edit } = this.props.props;
    if (privilege_edit === 1) {
      this.setState({ editprivilage: true });
    }
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleInputChoiceChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleInputWeightChange = (e) => {
    let newValue = e.target.value;
    if (newValue < 0) {
      newValue = 0;
    }
    this.setState({ currentWeight: newValue });
  };

  toggleaddItemModal = () => {
    const { addItemModal } = this.state;
    this.setState({
      addItemModal: !addItemModal,
    });
  };

  toggleEditFormSetupModal = () => {
    const { editFormSetupModal } = this.state;
    this.setState({
      editFormSetupModal: !editFormSetupModal,
    });
  };

  handleCheckboxChange = () => {
    this.setState((prevState) => ({
      show_user: !prevState.show_user,
    }));
  };

  handleAddItem = () => {
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      const { title, description, items, show_user, choices } = this.state;
      const { lg_user_id, lg_user_table_id, mid } = this.props.props;

      this.setState({ isLoading: true });

      if (items.length === 0) {
        sweetStatusAlert(
          "Warning",
          "At least one item must be added!",
          "warning"
        );
        this.setState({ isLoading: false });
        return;
      } else if (choices.length === 0) {
        sweetStatusAlert(
          "Warning",
          "Please add choices before saving.!",
          "warning"
        );
        this.setState({ isLoading: false });
        return;
      }
      const itemsPayload = items.map((item) => item.value);

      const object = {
        title: title,
        node_id: mid,
        show_user: show_user ? 1 : 0,
        create_user_id: lg_user_id,
        create_user_table_id: lg_user_table_id,
        description: description,
        items: itemsPayload,
        choices: choices,
      };

      evaluateBService
        .addformsetup(object)
        .then((res) => {
          if (res.success) {
            sweetStatusAlert("Success!", res.message.success, "success");
            this.validator.hideMessages();
            this.setState({
              title: "",
              description: "",
              currentItem: "",
              items: [],
              choices: [],
            });
          } else {
            sweetStatusAlert("Failed!", res.message.error, "error");
          }
        })
        .catch((error) => {
          sweetStatusAlert("Failed!", "Unable to add Form Setup!", "error");
        })
        .finally(() => {
          this.setState({
            isLoading: false,
          });
        });
    }
  };

  handleAddCurrentItem = () => {
    const { currentItem, items } = this.state;

    this.setState({
      items: [...items, { id: Date.now(), value: currentItem }],
      currentItem: "",
    });
  };

  handleAddCurrentchoice = () => {
    const { currentChoice, choices, currentWeight } = this.state;
    const weight = parseFloat(currentWeight); // Convert to number

    if (currentChoice.trim() !== "" && !isNaN(weight)) {
      this.setState({
        choices: [
          ...choices,
          { id: Date.now(), choice: currentChoice, weight },
        ],
        currentChoice: "",
        currentWeight: "",
      });
    } else {
      sweetStatusAlert(
        "Warning",
        "Type the choice and weight before you add!",
        "warning"
      );
    }
  };

  handleChoiceChange = (id, newValue) => {
    this.setState((prevState) => ({
      choices: prevState.choices.map((item) =>
        item.id === id ? { ...item, choice: newValue } : item
      ),
    }));
  };
  handleWeightChange = (id, newValue) => {
    const weight = parseFloat(newValue); // Convert to number

    this.setState((prevState) => ({
      choices: prevState.choices.map((item) =>
        item.id === id ? { ...item, weight } : item
      ),
    }));
  };

  handleChoiceRemove = (id) => {
    this.setState((prevState) => ({
      choices: prevState.choices.filter((choice) => choice.id !== id),
    }));
  };

  handleItemChange = (id, newValue) => {
    this.setState((prevState) => ({
      items: prevState.items.map((item) =>
        item.id === id ? { ...item, value: newValue } : item
      ),
    }));
  };

  handleRemoveItem = (id) => {
    this.setState((prevState) => ({
      items: prevState.items.filter((item) => item.id !== id),
    }));
  };

  handleRemoveChoices = (id) => {
    this.setState((prevState) => ({
      choices: prevState.choices.filter((choice) => choice.id !== id),
    }));
  };

  render() {
    const {
      items,
      title,
      description,
      isLoading,
      isTableDataLoading,
      currentItem,
      show_user,
      addItemModal,
      currentChoice,
      currentWeight,
      editFormSetupModal,
      editprivilage
    } = this.state;

    return (
      <>
        <div className="row justify-content-between align-items-center py-5 mb-3">
          <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Create Your Form</h3>
          </div>
          {editprivilage && (
            <div className="display-flex">
              <Button
                className="insert-btn"
                variant="primary"
                onClick={() => this.toggleEditFormSetupModal()}
              >
                Edit Created Forms
              </Button>
            </div>
          )}
        </div>

        <ManageEditFormSetupModel
          editFormSetupModal={editFormSetupModal}
          toggleEditFormSetupModal={this.toggleEditFormSetupModal}
          closeBtnStyle={closeBtnStyle}
          mid={this.props.props.mid}
        />

        {isLoading && <PageSpinner id="show" text="Loading, Please wait!" />}
        {isTableDataLoading ? (
          <div
            className="loading-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ overflow: "auto" }}>
            <Row>
              <Col md={12}>
                <Form>
                  <Row className="mb-3">
                  <Col md={8}>
                  <TextField
                    label="Title"
                    name="title"
                    value={title}
                    onChange={this.handleInputChange}
                    variant="outlined"
                    style={{ width: "100%", margin: "0 auto" }}
                  />
                  {this.validator.message("title", title, ["required", { max: 128 }], {
                    className: "text-danger",
                    messages: {
                      required: "The title is required.",
                      max: "You can only add up to 128 characters."
                    }
                  })}
                </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={8}>
                      <TextField
                        label="Description"
                        name="description"
                        value={description}
                        onChange={this.handleInputChange}
                        multiline
                        rows={4}
                        variant="outlined"
                        style={{ width: "100%", margin: "0 auto" }}
                      />
                      {this.validator.message(
                        "description", 
                        description, 
                        "max:1000", 
                        {
                          className: "text-danger",
                          messages: {
                            max: "You can only add up to 1000 characters." 
                          },
                        }
                      )}

                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={10}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <TextField
                          label="Add Item"
                          name="currentItem"
                          value={this.state.currentItem}
                          onChange={this.handleInputChange}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter" &&
                              this.state.currentItem.trim()
                            ) {
                              this.handleAddCurrentItem();
                            }
                          }}
                          variant="outlined"
                          style={{ width: "100%" }}
                        />
                        <IconButton
                          color="primary"
                          onClick={this.handleAddCurrentItem}
                          disabled={!this.state.currentItem.trim()}
                        >
                          <AddCircleOutline />
                        </IconButton>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <div>
                        {items.map((item) => (
                          <Row
                            key={item.id}
                            className="mb-2 align-items-center"
                          >
                            <Col md={10}>
                              <TextField
                                value={item.value}
                                onChange={(e) =>
                                  this.handleItemChange(item.id, e.target.value)
                                }
                                variant="outlined"
                                style={{ width: "100%" }}
                              />
                            </Col>
                            <Col xs="auto">
                              <IconButton
                                color="secondary"
                                onClick={() => this.handleRemoveItem(item.id)}
                              >
                                <Cancel />
                              </IconButton>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Check
                        type="checkbox"
                        label="Make it anonymous"
                        checked={show_user}
                        onChange={this.handleCheckboxChange}
                      />
                    </Col>
                  </Row>
                  <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={this.toggleaddItemModal}
                  >
                    Add choices
                  </Button>
                  <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={this.handleAddItem}
                  >
                    Save
                  </Button>
                </Form>
              </Col>

              <Modal
                size="md"
                aria-labelledby="contained-modal-subject-vcenter"
                centered
                show={addItemModal}
                onHide={this.toggleaddItemModal}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Add Choices to Added Items</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Form>
                    <Row className="my-4">
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Choice*</Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <TextField
                            label="Add Choices"
                            name="currentChoice"
                            value={currentChoice}
                            onChange={this.handleInputChoiceChange}
                            variant="outlined"
                            style={{ flex: 2 }}
                          />
                          <TextField
                            label="Add Weight"
                            name="currentWeight"
                            value={currentWeight}
                            onChange={this.handleInputWeightChange}
                            variant="outlined"
                            style={{ flex: 1 }}
                            type="number"
                          />
                          <IconButton
                            color="primary"
                            onClick={this.handleAddCurrentchoice}
                            disabled={!this.state.currentChoice.trim()}
                          >
                            <AddCircleOutline />
                          </IconButton>
                        </div>
                        <div className="mt-4">
                          {this.state.choices.map((item) => (
                            <Row
                              key={item.id}
                              className="mb-3 align-items-center"
                            >
                              <Col xs={8}>
                                <TextField
                                  value={item.choice}
                                  onChange={(e) =>
                                    this.handleChoiceChange(
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                  variant="outlined"
                                  style={{ width: "100%" }}
                                />
                              </Col>
                              <Col xs={3}>
                                <TextField
                                  value={item.weight}
                                  onChange={(e) =>
                                    this.handleWeightChange(
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                  variant="outlined"
                                  style={{ width: "100%" }}
                                  type="number"
                                />
                              </Col>
                              <Col xs={1}>
                                <IconButton
                                  color="secondary"
                                  onClick={() =>
                                    this.handleRemoveChoices(item.id)
                                  }
                                >
                                  <Cancel />
                                </IconButton>
                              </Col>
                            </Row>
                          ))}
                        </div>
                      </Form.Group>
                    </Row>
                  </Form>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    sx={{ mr: "20px" }}
                    onClick={this.toggleaddItemModal}
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </Row>
          </div>
        )}
      </>
    );
  }
}

export default ManageFormSetup;
